import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { find, get } from 'lodash';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';
import { DatasourceWizardService } from '../../../services/datasource/datasource.wizard.service';

@Component({
  selector: 'datasource-review-html',
  templateUrl: './datasource.review.page.html',
  providers: [],
  styleUrls: ['../datasource.style.scss', './datasource.review.style.scss']
})
export class DatasourceReviewComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  locationName: string;
  editMode: boolean;
  host: string;
  gigaFlowPort: string;
  userName: string;

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  get dataSourceHost(): any {
    return `${this.host}`;
  }

  constructor(private wizardService: DatasourceWizardService) {}

  ngOnInit() {
    this.step.form = this.form;
    this.editMode = this.wizardService.editMode;
    this.userName = this.getParamValues('username');
    this.host = this.getParamValues('host');
    this.gigaFlowPort = this.getParamValues('gigaflow-port');
    if (this.wizardCtrl.wizardId === 'add_agent') {
      this.setSiteInfo();
    }
    this.locationName = this.step.parent.output.locationName;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getParamValues(key: any): any {
    const param = find(this.step.parent.output.params, function (obj) {
      return obj.name === key;
    });
    return get(param, 'value', '');
  }

  setSiteInfo(): void {
    const defaultParams = this.wizardCtrl.wizardService.defaultParamsById;
    this.step.parent.output['point'] = {
      latitude: defaultParams.location.latitude,
      longitude: defaultParams.location.longitude
    };
    this.step.parent.output['siteId'] = defaultParams.siteId;
    this.step.parent.output['location'] = defaultParams.siteId;
    this.step.parent.output['siteName'] = defaultParams.siteName;
    this.step.parent.output['country'] = defaultParams.location.country;
    this.step.parent.output['city'] = defaultParams.location.city;
    this.step.parent.output['type'] = 'ONGOING';
  }
}
